import React, { useState } from 'react';
import HamburgerMenu from 'react-hamburger-menu';
import { Link } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import TheInsideLogo from '@/common/svgs/TheInsideLogo';
import MenuMobile from '@/common/navigation/mobile/RebrandedMenuMobile/MenuMobile';
import useMedia from '@/hooks/useMedia';

function NavigationMobile({ setShowSearch }) {
  const [toggle, setToggle] = useState(false);
  const isMobile = useMedia('(max-width: 375px)');
  const theme = useTheme();

  const handleHamburger = () => {
    setToggle(!toggle);
  };

  const closeMenu = () => {
    setToggle(false);
  };

  return (
    <Wrapper>
      <MenuMobile
        toggle={toggle}
        closeMenu={closeMenu}
        search={setShowSearch}
      />

      <Link to="/" aria-label="The Inside">
        <TheInsideLogo
          className="logo-nav-mobile"
          isScrolling={true}
          horizontal={isMobile}
        />
      </Link>

      <div className="right-side-container">
        <HamburgerMenu
          className="hamburger-menu"
          isOpen={toggle}
          menuClicked={handleHamburger}
          width={21}
          height={13}
          strokeWidth={1}
          rotate={0}
          color={theme.colors.charcoal}
          borderRadius={0}
          animationDuration={0.3}
        />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  align-items: center;
  background: white;
  display: flex;
  height: 60px;
  justify-content: flex-start;
  position: relative;
  z-index: 1002;
  padding: 14px 0;

  @media (min-width: 376px) {
    justify-content: center;
  }

  .logo-nav-mobile {
    width: 178px;
    height: auto;
    padding-left: 17px;
    @media (min-width: 376px) {
      width: 140px;
    }
  }

  .hamburger-menu {
    z-index: 1001;
    span {
      background-color: black;
    }
  }

  .right-side-container {
    position: absolute;
    right: 0;
    margin-right: 20px;
  }
`;

export default NavigationMobile;
